import type { ReactNode } from 'react'
import { Navigate, useParams } from 'react-router-dom'
import { isFeatureEnabled, getDisabledBehavior } from '../../lib/featureFlags'
import type { FlagKey } from '../../config/flags'
import MaintenancePage from './MaintenancePage'

interface FeatureGateProps {
  flag: FlagKey
  children: ReactNode
}

/**
 * Page-level gate. When the flag is off, behavior depends on getDisabledBehavior:
 *  - 'hide'         → redirect to /<lang>/* (404)
 *  - 'coming-soon'  → coming-soon page
 *  - 'maintenance'  → maintenance page
 */
export default function FeatureGate({ flag, children }: FeatureGateProps) {
  const { lang = 'en' } = useParams<{ lang: string }>()
  const enabled = isFeatureEnabled(flag)
  if (enabled) return <>{children}</>

  const behavior = getDisabledBehavior(flag)
  if (behavior === 'hide') return <Navigate to={`/${lang}/__not-found`} replace />
  if (behavior === 'coming-soon') return <MaintenancePage variant="coming-soon" />
  return <MaintenancePage variant="maintenance" />
}
